import React from 'react';
import { PatternFormat, NumberFormatValues } from 'react-number-format';
import { TextField, InputLabel, Stack, SxProps, Theme, TextFieldProps } from '@mui/material';

export interface CommonPhoneInputProps {
  value?: string | null;
  onChange: (value: string) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  valueType?: 'formatted' | 'raw';
  format?: string;
  mask?: string;
  placeholder?: string;
  label?: string;
  error?: boolean;
  helperText?: React.ReactNode;
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  variant?: 'outlined' | 'filled' | 'standard';
  name?: string;
  id?: string;
  sx?: SxProps<Theme>;
  slotProps?: TextFieldProps['slotProps'];
  InputProps?: TextFieldProps['InputProps'];
  inputRef?: React.Ref<any>;
}

export const CommonPhoneInput: React.FC<CommonPhoneInputProps> = ({
  value,
  onChange,
  onBlur,
  valueType = 'formatted',
  format = '###-###-####',
  mask = '_',
  placeholder = '___-___-____',
  label,
  error = false,
  helperText,
  disabled = false,
  readOnly = false,
  required = false,
  fullWidth = true,
  size = 'medium',
  variant = 'outlined',
  name,
  id,
  sx,
  slotProps,
  InputProps,
  inputRef
}) => {
  const handleValueChange = (values: NumberFormatValues) => {
    if (valueType === 'raw') {
      onChange(values.value || '');
    } else {
      onChange(values.formattedValue || '');
    }
  };

  const inputComponent = (
    <PatternFormat
      value={value || ''}
      format={format}
      mask={mask}
      placeholder={placeholder}
      customInput={TextField}
      fullWidth={fullWidth}
      size={size}
      variant={variant}
      error={error}
      helperText={helperText}
      disabled={disabled || readOnly}
      name={name}
      id={id}
      sx={sx}
      inputRef={inputRef}
      onValueChange={handleValueChange}
      onBlur={onBlur}
      slotProps={slotProps}
      InputProps={InputProps}
    />
  );

  if (label) {
    return (
      <Stack spacing={0.75}>
        <InputLabel required={required}>{label}</InputLabel>
        {inputComponent}
      </Stack>
    );
  }

  return inputComponent;
};

export default CommonPhoneInput;
